<template>
    <div class="container">

        <div class="row">
            <div class="col-10">
                <h1>
                    <a href="#" @click.prevent.stop="showCart=false">Autovaruosade hinnavõrdlus</a>
                </h1>
            </div>
            <div class="col-2 text-right align-middle">
                <h1><cart-button v-on:click="showCart=true"></cart-button></h1>
            </div>
        </div>

        <div class="row" v-show="!showCart">
            <div class="col-12">
                <form class="form-inline" v-on:submit.prevent>
                    <b-form-input
                            type="text"
                            id="searchInput"
                            v-model="searchTerm"
                            class="col-10"
                            :formatter="strip"
                            placeholder="Sisesta tootekood, näiteks 1 457 429 152"
                            v-on:keyup.enter="searchClick"
                    ></b-form-input>
                    <button type="button" @click="searchClick" class="btn btn-primary col-2" :disabled="searching">
                        <b-icon-search></b-icon-search>
                        <span v-if="!searching">&nbsp;Näita hinda</span>
                        <span v-else>&nbsp;Otsing...</span>
                    </button>
                </form>
            </div>
        </div>

        <div class="row" v-show="showCart">
            <div class="col-12">
                <cart></cart>
            </div>
        </div>

        <parser
                v-show="!showCart"
                v-bind:search-term="searchTerm"
                v-bind:item-count="itemCount"
                v-bind:searching="searching"
                v-on:search="search"
        ></parser>

        <div class="row" v-show="searching">
            <div class="col-12 text-md-center">
                <b-icon-three-dots animation="cylon" font-scale="6"></b-icon-three-dots>
            </div>
        </div>
        <div class="small text-center text-secondary">
            <br />
            Antud keskkond pakub hinnavõrdluse teenust kasutades autovaruosade edasimüüjate veebilehtedel olevat avaliku infot.
            Me ei vastuta andmete korrektsuse, osade kättesaadavuse ja reaalsete hindade eest.
            <br />
            <br />
        </div>
    </div>
</template>

<script>

    import { BIconSearch, BFormInput, BIconThreeDots } from 'bootstrap-vue';
    import CartButton from './components/CartButton'
    import Cart from './components/Cart'
    import Parser from "./components/Parser";
    import { asciiOnly } from './utils.js'

    export default {
        name: "Parser",
        components: {
            'b-icon-search': BIconSearch,
            'b-form-input': BFormInput,
            'cart-button': CartButton,
            'b-icon-three-dots': BIconThreeDots,
            'cart': Cart,
            'parser': Parser,
        },
        data: function() {
            return {
                searchTerm: "",// "3200701",
                showCart: false,
            };
        },
        methods: {
            recaptcha: function() {
                return new Promise((resolve) => {
                    this.$recaptchaLoaded().then(() => {
                        this.$recaptcha('homepage').then((token) => {
                            resolve(token)
                        });
                    });
                });
            },
            search: function(str) {
                this.clear();
                this.recaptcha().then((token) => {
                    this.actualSearch(str, token);
                });
            },
            actualSearch: function(str, token){
                this.$data.searchTerm = str;
                this.$store.dispatch('list/setSearchTerm', asciiOnly(str));
                this.$store.dispatch('runSearch', {
                    term: asciiOnly(str),
                    token: token
                });
            },
            searchClick: function() {
                let term = this.$data.searchTerm;
                if (term.length < 3) {
                    this.$data.searchTerm = '';
                    return;
                }
                this.search(this.$data.searchTerm);
            },
            clear: function() {
                this.$store.dispatch('clearFound');
            },
            strip: function(str) {
                return asciiOnly(str);
            },
        },
        computed: {
            searching: function() {
                return this.$store.state.searching;
            },
            itemCount: function() {
                return this.$store.getters['list/count'];
            },
        }
    }
</script>

<style lang="scss">
    @import 'node_modules/bootstrap/scss/bootstrap';
    @import 'node_modules/bootstrap-vue/src/index.scss';
    @import 'node_modules/bootstrap-vue/src/icons.scss';
</style>